/** SVG data-URIs for operational warehouse services */
const svg = (body) =>
	`data:image/svg+xml,${encodeURIComponent(
		`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#4b5568" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round">${body}</svg>`
	)}`;

export const IconIn = svg(`
	<path d="M12 2v12"/>
	<path d="M7 9l5 5 5-5"/>
	<path d="M4 21h16"/>
	<path d="M4 21v-3h16v3"/>
`);

export const IconOut = svg(`
	<path d="M12 22V10"/>
	<path d="M7 15l5-5 5 5"/>
	<path d="M4 3h16"/>
	<path d="M4 3v3h16V3"/>
`);

/** Surtido = carrito de picking con caja */
export const IconSurtido = svg(`
	<circle cx="8" cy="20" r="1.6"/>
	<circle cx="18" cy="20" r="1.6"/>
	<path d="M3 4h2l2.2 10.2a1.5 1.5 0 0 0 1.5 1.2H18"/>
	<path d="M7.5 14.5h10.2l1.6-6.5H6.4"/>
	<path d="M11 5.5h5.2v4.2H11z"/>
	<path d="M13.6 5.5V4.2h2.2"/>
`);

export const IconFullfilment = svg(`
	<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
	<path d="M3.3 7L12 12l8.7-5"/>
	<path d="M12 22V12"/>
`);

/** Maquila = ensamble / trabajo de manufactura */
export const IconMaquila = svg(`
	<path d="M14.7 6.3a4.2 4.2 0 0 0-5.9 5.9l-5.3 5.3a1.5 1.5 0 0 0 2.1 2.1l5.3-5.3a4.2 4.2 0 0 0 5.9-5.9l-2.4 2.4-2.1-2.1 2.4-2.4z"/>
	<path d="M16.5 3.5l4 4"/>
`);

export const IconControl = svg(`
	<path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/>
	<rect x="9" y="3" width="6" height="4" rx="1"/>
	<path d="M9 12h6M9 16h4"/>
`);

export const IconWMS = svg(`
	<rect x="3" y="4" width="18" height="12" rx="2"/>
	<path d="M8 20h8M12 16v4"/>
	<path d="M7 9h4v4H7zM13 9h4"/>
`);

export const IconLogistica = svg(`
	<path d="M3 12a9 9 0 0 1 15.5-6.4"/>
	<path d="M18.5 3v4h-4"/>
	<path d="M21 12a9 9 0 0 1-15.5 6.4"/>
	<path d="M5.5 21v-4h4"/>
`);

export const IconIMMEX = svg(`
	<circle cx="12" cy="12" r="9"/>
	<path d="M3 12h18"/>
	<path d="M12 3a14 14 0 0 1 0 18"/>
	<path d="M12 3a14 14 0 0 0 0 18"/>
`);

export const IconCross = svg(`
	<path d="M12 3v18"/>
	<path d="M3 12h6"/>
	<path d="M15 12h6"/>
	<path d="M9 8l-3 4 3 4"/>
	<path d="M15 8l3 4-3 4"/>
`);

export const IconAcuerdo = svg(`
	<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
	<path d="M14 2v6h6"/>
	<path d="M9 13l2 2 4-4"/>
`);

/** Empacado = caja cerrandose con cinta por el centro */
export const IconEmpacado = svg(`
	<path d="M3 8.5h18v11a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 19.5z"/>
	<path d="M3 8.5L5.5 3h13L21 8.5"/>
	<path d="M12 3v18"/>
	<path d="M9.5 12h5"/>
`);

/** Etiquetado = etiqueta con perforacion */
export const IconEtiquetado = svg(`
	<path d="M20.6 12.4l-8.2 8.2a2 2 0 0 1-2.8 0l-6.2-6.2a2 2 0 0 1-.6-1.4V4.8A1.8 1.8 0 0 1 4.6 3h8.2a2 2 0 0 1 1.4.6l6.4 6.4a2 2 0 0 1 0 2.8z"/>
	<circle cx="8" cy="8" r="1.6"/>
`);

/** Armado de kits = varias piezas que entran en una sola caja */
export const IconKits = svg(`
	<path d="M3 13.5h8.5V21H4.5A1.5 1.5 0 0 1 3 19.5z"/>
	<path d="M14 13.5h7v6a1.5 1.5 0 0 1-1.5 1.5H14z"/>
	<path d="M7 3h10l1.5 5.5h-13z"/>
	<path d="M12 8.5v5"/>
	<path d="M9 11l-3 2.5"/>
	<path d="M15 11l3 2.5"/>
`);

/** Retractilado = tarima envuelta en playo */
export const IconRetractilado = svg(`
	<path d="M5 4.5h14v12H5z"/>
	<path d="M5 8.5h14"/>
	<path d="M5 12.5h14"/>
	<path d="M8.5 4.5v12"/>
	<path d="M15.5 4.5v12"/>
	<path d="M3.5 20h17"/>
	<path d="M6.5 20v-3.5"/>
	<path d="M17.5 20v-3.5"/>
`);
